import { FILE_DATA, LOADER_STATUS, SAVE_TOTAL_PAGES, SET_MULTIPLE_GSTIN_DATA, SET_TABLE_DATA } from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    totalPages: 1,
    tableData:[],
    multipleGstinTableData:[],
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr1NewUploadReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
        case FILE_DATA:
          return {
            ...state,
            fileData:action.fileData
          }
          case SET_TABLE_DATA:
            return {
              ...state,
              tableData:action.tableData
            }
        case SAVE_TOTAL_PAGES:
          return {
            ...state,
            totalPages:action.pages
          }
        case SET_MULTIPLE_GSTIN_DATA:
          return{
            ...state,
            multipleGstinTableData: action.multipleGstinTableData

          }
        default:
          return state;
      }
    };
  
  export default gstr1NewUploadReducer;